import { render, staticRenderFns } from "./TableInspectCustomEp.vue?vue&type=template&id=4893ead2&scoped=true"
import script from "./TableInspectCustomEp.vue?vue&type=script&lang=js"
export * from "./TableInspectCustomEp.vue?vue&type=script&lang=js"
import style0 from "./TableInspectCustomEp.vue?vue&type=style&index=0&id=4893ead2&prod&scoped=true&lang=scss"
import style1 from "./TableInspectCustomEp.vue?vue&type=style&index=1&id=4893ead2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4893ead2",
  null
  
)

export default component.exports